import { baseApi } from "api/BaseApi";

import {
  PublicGroupedMaintenance,
  PublicMaintenance,
} from "./maintenance.types";

const PCL_MAINTENANCE_BASE_URL = "/project/maintenance";

const maintenanceApi = baseApi.injectEndpoints({
  endpoints: (build) => ({
    getGroupedMaintenances: build.query<PublicGroupedMaintenance, void>({
      query: () => "/project/maintenance/get_grouped/",
    }),

    getMaintenanceByMaintId: build.query<PublicMaintenance, string>({
      query: (maintenance_id) => ({
        url: `${PCL_MAINTENANCE_BASE_URL}/get_frontend_maintenance_by_maintenance_id/`,
        params: { maintenance_id },
      }),
    }),

    maintenanceByProductId: build.query<PublicMaintenance[], string | number>({
      query: (product_id) => ({
        url: `${PCL_MAINTENANCE_BASE_URL}/get_maintenance_by_product/`,
        params: { product_id },
      }),
    }),
  }),

  overrideExisting: false,
});

export const {
  useGetGroupedMaintenancesQuery,
  useGetMaintenanceByMaintIdQuery,
  useMaintenanceByProductIdQuery,
} = maintenanceApi;
